import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_14: FaireProductEntity = {
  token: "legacy_prod_abbott-14",
  type: "product",
  name: "White LED Taper Candle 9.5 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e07a5dc42867fb51fc810c645c11e5a44c17bebb9dbae1efc2170f7e255dceea.jpeg",
  priceDollars: 14,
  msrpDollars: 28,
  isBestseller: true,
  subcategory: "Taper Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
